export default __webpack_public_path__ + "static/media/process1.9b0cd557.svg";